import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ErrorBoundary from 'components/ErrorBoundary';
import s from './USElectionResultWrapper.scss';
import UsMainBattle from '../../../components/ElectionV2/usElection/UsMainBattle/UsMainBattle';
import UsStateBattle from '../../../components/ElectionV2/usElection/UsStateBattle/UsStateBattle';
import Listingheader from '../../../routes/home/components/common/ListingheaderV2';
import {
  filterSearchSortData,
  loadUSElectionData,
} from '../../../components/ElectionV2/uselection_redux';
import InputSearch from '../InputSearch';

class USElectionResultWrapper extends React.Component {
  constructor(props) {
    super(props);
    try {
      const { states = [] } = this.props;
      this.state = {
        searches: {},
      };
      this.tabRefs = states.reduce((acc, tab) => {
        acc[tab.key] = React.createRef();
        return acc;
      }, {});
    } catch (error) {
      // Error Occurred
    }
  }

  componentDidMount() {
    this.props.fetchElectionData({
      refreshinterval: this.props.refreshinterval,
      result: this.props.result,
      displaytext: this.props.displaytext,
      path: this.props.path,
      hideexitheading: this.props.hideexitheading,
      datasource: this.props.datasource,
      keywords: this.props.keywords,
      breakingnews: this.props.breakingnews,
      states: this.props.states,
      liveblog: this.props.liveblog,
      shareTitle: this.props.shareTitle,
      inpageminitv: this.props.inpageminitv,
      iframeUrl: this.props.iframeUrl,
      searches: this.state.searches,
    });
    this.refreshData();
  }

  refreshData = () => {
    const { refreshinterval } = this.props;
    if (refreshinterval) {
      this.electionWidgetInterval = setInterval(() => {
        this.props.fetchElectionData({
          refreshinterval: this.props.refreshinterval,
          result: this.props.result,
          displaytext: this.props.displaytext,
          path: this.props.path,
          hideexitheading: this.props.hideexitheading,
          datasource: this.props.datasource,
          keywords: this.props.keywords,
          breakingnews: this.props.breakingnews,
          states: this.props.states,
          liveblog: this.props.liveblog,
          shareTitle: this.props.shareTitle,
          inpageminitv: this.props.inpageminitv,
          iframeUrl: this.props.iframeUrl,
          searches: this.state.searches,
        });
      }, refreshinterval * 1000);
    }
  };

  componentWillUnmount() {
    clearInterval(this.electionWidgetInterval);
  }

  debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  debouncedSearch = this.debounce(searches => {
    this.props.filterData(searches);
  }, this.DEBOUNCE_DELAY);

  handleSearchChange = e => {
    const term = e.target.value;
    this.setState(
      { searches: { ...this.state.searches, stateName: term } },
      () => {
        this.debouncedSearch(this.state.searches);
      },
    );
  };

  render() {
    const {
      // isWapView,
      bgColor,
      bgColorOuter,
      states = [],
      datasource,
      sortedData,
      refreshinterval,
      iframeUrl,
    } = this.props;

    if (!refreshinterval) {
      return null;
    }

    const allStates =
      sortedData?.filteredStates &&
      typeof sortedData?.filteredStates === 'object'
        ? Object.values(sortedData?.filteredStates)
        : [];

    const backGroundStyle = bgColor ? `#${bgColor}` : '';

    const backGroundStyleOuter = bgColorOuter ? `#${bgColorOuter}` : '';

    return (
      <div className={`${`election_widget`}`} ref={this.ref}>
        <div
          className={`${s.electionWidget} globalElectionWidget`}
          style={{ backgroundColor: backGroundStyleOuter }}
        >
          <div
            style={{ backgroundColor: backGroundStyle }}
            className={s.electionInner}
          >
            <div className={s.usElectionMainWrapper}>
              <div>
                <div className={s.topStatusWrap}>
                  <div className={s.resultWrap}>
                    <ErrorBoundary>
                      <UsMainBattle {...sortedData.nation} />
                    </ErrorBoundary>
                  </div>
                </div>
                <div className={s.mapIframe}>
                  <iframe
                    className="ap-embed"
                    title="Live election results via the Associated Press"
                    src={iframeUrl}
                    width="100%"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight="0"
                  />
                  <script
                    defer
                    src="https://interactives.ap.org/election-results/assets/microsite/resizeClient.js"
                  />
                </div>
              </div>
              <div className={s.topGap}>
                <Listingheader headingname="Key States" />
                <div className={s.gridView}>
                  {states &&
                    Array.isArray(states) &&
                    states.length > 0 &&
                    states.map(
                      state =>
                        sortedData.states?.[state?.key] && (
                          <ErrorBoundary>
                            <UsStateBattle
                              {...sortedData.states?.[state?.key]}
                            />
                          </ErrorBoundary>
                        ),
                    )}
                </div>
              </div>
              <div className={s.topGap}>
                <div className={s.otherTopHead}>
                  <Listingheader headingname="Other States" />
                  <div className={s.searchBox}>
                    <InputSearch
                      placeholder="Search States"
                      searchHandler={this.handleSearchChange}
                    />
                  </div>
                </div>
                <div className={s.gridView}>
                  {allStates &&
                    Array.isArray(allStates) &&
                    allStates.length > 0 &&
                    allStates.map(
                      state =>
                        state.powerState !== '1' && (
                          <ErrorBoundary>
                            <UsStateBattle {...state} />
                          </ErrorBoundary>
                        ),
                    )}
                </div>
              </div>
              {datasource && (
                <span className={`${s.sourceText}`}>{datasource}</span>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  refreshinterval: state?.usElection?.refreshinterval,
  electionData: state?.usElection?.electionData,
  displaytext: state?.usElection?.displaytext,
  keywords: state?.usElection?.keywords,
  breakingnews: state?.usElection?.breakingnews,
  states: state?.usElection?.states,
  liveblog: state?.usElection?.liveblog,
  datasource: state?.usElection?.datasource,
  hideexitheading: state?.usElection?.hideexitheading,
  path: state?.usElection?.path,
  shareTitle: state?.usElection?.shareTitle,
  sortedData: state?.usElection?.sortedData,
  result: state?.usElection?.result,
  inpageminitv: state?.usElection?.inpageminitv,
  iframeUrl: state?.usElection?.iframeUrl,
});

const mapDispatchToProps = dispatch => ({
  fetchElectionData: data => {
    dispatch(loadUSElectionData(data));
  },
  filterData: (searches, loader = false) => {
    dispatch(filterSearchSortData(searches, loader));
  },
});

USElectionResultWrapper.propTypes = {
  isWapView: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
  }),
  hideETheading: PropTypes.bool,
  hideExitHeading: PropTypes.bool,
  bgColor: PropTypes.string,
  hideSharing: PropTypes.bool,
  bgColorOuter: PropTypes.string,
  isPowerByAd: PropTypes.shape({}),
  isPowerByAdActive: PropTypes.number,
  showDots: PropTypes.bool,
  ettxt: PropTypes.string,
  hideDisplayText: PropTypes.bool,
  electionwdtWap: PropTypes.bool,
};
USElectionResultWrapper.defaultProps = {
  isWapView: false,
  data: {},
  hideETheading: false,
  hideExitHeading: false,
  hideSharing: false,
  bgColor: '',
  bgColorOuter: '',
  isPowerByAd: null,
  isPowerByAdActive: 0,
  showDots: false,
  hideDisplayText: false,
  electionwdtWap: false,
  ettxt: '',
};

export default connect(mapStateToProps, mapDispatchToProps)(
  USElectionResultWrapper,
);
